import { Button as MuiButton } from "@material-ui/core";
import React from "react";

import type { ReplaceProperties } from "../../../types/replaceProperties";
import type { ButtonProps as MuiButtonProps } from "@material-ui/core";

// Chakra UI Button の型定義
// サイズの型定義
const CHAKRA_BUTTON_SIZES = ["xs", "sm", "md", "lg"] as const;
type ChakraButtonSize = (typeof CHAKRA_BUTTON_SIZES)[number];

// バリアントの型定義
const CHAKRA_BUTTON_VARIANTS = ["solid", "outline", "ghost"] as const;
type ChakraButtonVariant = (typeof CHAKRA_BUTTON_VARIANTS)[number];

// Chakra UI の variant を Material UI の variant にマッピング
const VARIANT_MAP: Record<ChakraButtonVariant, MuiButtonProps["variant"]> = {
  solid: "contained",
  outline: "outlined",
  ghost: "text",
};

// Chakra UI の size を Material UI の size にマッピング
const SIZE_MAP: Record<ChakraButtonSize, MuiButtonProps["size"]> = {
  xs: "small",
  sm: "small",
  md: "medium",
  lg: "large",
};

// Chakra UI Button のProps
type ChakraButtonProps = {
  variant?: ChakraButtonVariant;
  size?: ChakraButtonSize;
  icon?: React.ReactNode;
};

// ReplaceProperties を使用した Props 型定義
type Props = ReplaceProperties<MuiButtonProps, ChakraButtonProps>;

// Button コンポーネント
export const Button: React.FC<Props> = ({
  variant = "solid",
  size = "md",
  icon,
  ...rest
}) => {
  // Chakra のPropsを MUI のPropsに変換
  const muiVariant = VARIANT_MAP[variant];
  const muiSize = size ? SIZE_MAP[size] : undefined;

  return (
    <MuiButton
      startIcon={icon}
      variant={muiVariant}
      {...(muiSize && { size: muiSize })}
      {...rest}
    />
  );
};
